import { parseLocalDate } from './dateUtils';

export interface DateRangeValidation {
  header: string;
  missingTasks: string[];
  missingHours: string[];
  hasIssues: boolean;
}

function formatDayLabel(dateStr: string): string {
  const d = parseLocalDate(dateStr);
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${days[d.getDay()]}, ${d.getDate()} ${months[d.getMonth()]}`;
}

function formatHeaderDate(dateStr: string): string {
  const d = parseLocalDate(dateStr);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

export function validateDateRangeEntries(
  entries: any[],
  from: string,
  to: string
): DateRangeValidation {
  const header = `${formatHeaderDate(from)} – ${formatHeaderDate(to)}`;
  const missingTasks: string[] = [];
  const missingHours: string[] = [];

  for (const entry of entries) {
    const dateStr = typeof entry.entry_date === 'string'
      ? entry.entry_date.substring(0, 10)
      : new Date(entry.entry_date).toISOString().substring(0, 10);

    const d = parseLocalDate(dateStr);
    const day = d.getDay();

    // Skip weekends
    if (day === 0 || day === 6) continue;

    const label = formatDayLabel(dateStr);
    const taskDetails = (entry.task_details || '').trim();
    const totalHours = Number(entry.total_hours || 0);

    if (!taskDetails) {
      missingTasks.push(label);
    }
    if (totalHours === 0) {
      missingHours.push(label);
    }
  }

  return {
    header,
    missingTasks,
    missingHours,
    hasIssues: missingTasks.length > 0 || missingHours.length > 0,
  };
}
